import { theTime } from "src/app/utils/date-utils";

export const getDayDictKey = (date: Date) =>
  theTime(date).to(["DD", "MM", "YYYY"], "-");
  // Used to be one character day and month...
  //`${date.getDate()}-${date.getMonth()}-${date.getFullYear()}`;

export const getHourDictKey = (date: Date) =>
  theTime(date).to(["HH", "DD", "MM", "YYYY"], "-");
  // Used to be one character day and month...
  //`${date.getHours()}-${date.getDate()}-${date.getMonth()}-${date.getFullYear()}`;
